/**
 * Public Booking Page
 * Allows external users to book meetings with a host
 */

import { useParams, useSearchParams } from 'react-router-dom';
import { BookingCalendar } from '@/components/booking';
import { useLanguage } from '@/contexts/LanguageContext';

export default function BookingPage() {
  const { hostId } = useParams<{ hostId: string }>();
  const [searchParams] = useSearchParams();
  const { language } = useLanguage();

  const hostName = searchParams.get('name') || (language === 'fr' ? 'Hôte' : 'Host');
  const dealId = searchParams.get('deal') || undefined;
  const title = searchParams.get('title') || undefined;

  if (!hostId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-muted-foreground">
          {language === 'fr' ? 'Lien de réservation invalide' : 'Invalid booking link'}
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted/30 py-12 px-4">
      <BookingCalendar
        hostId={hostId}
        hostName={hostName}
        dealId={dealId}
        defaultTitle={title}
      />
    </div>
  );
}
